import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Terms and Conditions',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.save-term',
            },
          },
          {
            '{}': {
              alias: 'sr.delete-term',
            },
          },
        ],
      },
      content: {
        '{}': {
          query: {
            '`': {
              target: 'ent:!subaward_tcs:!tc',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      risk_threshold: {
                        '{}': {
                          value: {
                            '@.': '!risk_threshold',
                          },
                        },
                      },
                      activity: {
                        '{}': {
                          value: {
                            '@': 'monitorActNames',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'sr.conditions.widgets.edit-term',
                                },
                              },
                              variables: {
                                '{}': {
                                  termId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'sr.delete-term',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete Term',
                          message:
                            'Are you sure that you want to delete this term?',
                        },
                      },
                      variables: {
                        '{}': {
                          termId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                tcMonitorActs: {
                  ref: {
                    attr: 'attr:ent#!subaward_tc_monitor_act#!entry:!tc',
                  },
                  target: 'ent:!subaward_tc_monitor_act:!entry',
                },
                monitorActNames: {
                  ref: {
                    attr: 'attr:ent#!subaward_tc_monitor_act#!entry:!activity',
                  },
                  using: 'tcMonitorActs',
                  target: 'ent:!subaward_monitor_acts:!activity',
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subaward_tcs#!tc:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subaward_tcs#!tc:!descr',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'risk_threshold',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!subaward_tcs#!tc:!risk_threshold',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'activity',
                  dmsRef: {
                    '{}': {
                      source: 'attr:ent#!subaward_tc_monitor_act#!entry:!tc',
                      target:
                        'attr:ent#!subaward_tc_monitor_act#!entry:!activity',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.conditions.widgets.edit-term',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
